/**
 * Which of the survey's variables a variables list holds back, and whether the Data Cleaning preset is
 * offered. Every list the report builds from the survey's variables -- the Filters tab, View options,
 * the split-by groups, the Virtual Question and mapping editors -- asks here, so what a reader may see
 * is decided once rather than by a copy per list.
 */

import { viewerIsAdmin } from '@aytm/app/stats/lib/page/viewer'

// fielding bookkeeping, not answers; the Filters tab gives them back to an admin under Others
export const SYSTEM_VARIABLES = ['puid', 'panel', 'group', 'group_id']

// a respondent's own identifiers, withheld from the lists that split or cross the report by a variable
export const IDENTITY_VARIABLES = ['uid', 'last_ref']

// the stats service registers these for an admin only, so no other reader is offered them even when
// they reach the page
export const DC_SUSPICION_VARIABLES = ['data_centrifuge_suspicion', 'data_centrifuge_suspicion_level']

const DC_SUSPICION_LEVEL = 'data_centrifuge_suspicion_level'

const registered = (refsList, key) => Object.hasOwn(refsList || {}, key.toUpperCase())

export const dcSuspicionPresetOffered = ({ features = {}, refsList = {}, isAdmin = viewerIsAdmin() } = {}) =>
  registered(refsList, DC_SUSPICION_LEVEL) && !features.stat_data_cleaning?.disabled && isAdmin

/**
 * `identity` adds the respondent identifiers; `dcPreset` is for a list shown beside the Data Cleaning
 * preset, which then carries the suspicion level instead of the list.
 */
export const heldBackVariables = ({
  features = {},
  refsList = {},
  identity = false,
  dcPreset = false,
  isAdmin = viewerIsAdmin()
} = {}) => {
  const held = [...SYSTEM_VARIABLES, ...(identity ? IDENTITY_VARIABLES : [])]

  if (features.fielding_health_status?.disabled) held.push('status')

  if (!isAdmin) held.push(...DC_SUSPICION_VARIABLES)
  else if (dcPreset && dcSuspicionPresetOffered({ features, refsList, isAdmin })) held.push(DC_SUSPICION_LEVEL)

  return held
}
